<div *ngIf="!showRequest">

    <!-- <h2 *ngIf="isShow && !IsFinalFeesReview" class="sectionTitle">{{'ADMIN_USER.SmallUnits.FINALFEES_FORM' | translate }}</h2>
    <h2 *ngIf="isShow && IsFinalFeesReview" class="sectionTitle">{{'ADMIN_USER.SmallUnits.REVIEW_FINALFEES_FORM' | translate }}</h2> -->
    <h2 *ngIf="isShow" class="sectionTitle">{{'ADMIN_USER.SmallUnits.FINALFEES_FORM' | translate }}</h2>
    <div *ngIf="isLoaded && baseRequestId" class="read-only-content">
      <!--request Details summary-->
      <app-register-measurment [isShow]="false"></app-register-measurment>
      <app-confirm-transit [ShowRequestdetails]="false" [isShow]="false"></app-confirm-transit>
    </div>

    <!-- <div *ngIf="baseRequestId"> -->
    <form #finalFees [formGroup]="finalFeesForm">
      <fieldset [disabled]="this.finalFeesForm.disabled">
        <div class="form-container">
            <div class="form-section">
        <!-- Fees Section -->
          <h4 class="section-title">{{'ADMIN_USER.SmallUnits.FINALFEES_TRANSIT_FEES'| translate}}</h4>

          <!-- <div class="form-group">
            <label for="EstimatedNetTonnage">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.SUEZ_CANNAL_NET_TONNAGE' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="EstimatedNetTonnage" id="EstimatedNetTonnage" name="EstimatedNetTonnage" (change)="NetTonnageChange($event)" class="form-control" />
            <div *ngIf="submitted || (f.EstimatedNetTonnage?.dirty &&f.EstimatedNetTonnage?.errors)" class="red">
              <div *ngIf="f.EstimatedNetTonnage?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.EstimatedNetTonnage?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
            </div>
          </div> -->
          <div class="form-group">
            <label for="FinalSDR">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SDR_RATE' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="FinalSDR" id="FinalSDR" name="FinalSDR" (change)="finalSDRChanged($event)" class="form-control" />
            <label><a style="text-decoration: underline!important;color: #428bca!important;" href="{{ 'FRONT_USER.FEES_ESTIMATION_FORM.IMF_LINK' | translate}}" target="_blank">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.LINK_TO_IMF' | translate}}</a></label>
            <div *ngIf="submitted || (f.FinalSDR?.dirty &&f.FinalSDR?.errors)" class="red">
              <div *ngIf="f.FinalSDR?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.FinalSDR?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
            </div>
          </div>

          <div class="form-group">
            <label for="FinalTransitFeesValue">{{ 'ADMIN_USER.SmallUnits.FINALFEES_TRANSIT_FEES' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="FinalTransitFeesValue" id="FinalTransitFeesValue" name="FinalTransitFeesValue"
              class="form-control" (change)="serviceValueChanged()"/>
            <div *ngIf="submitted || (f.FinalTransitFeesValue?.dirty &&f.FinalTransitFeesValue?.errors)" class="red">
              <div *ngIf="f.FinalTransitFeesValue?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.FinalTransitFeesValueValue?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
            </div>
          </div>

          <div class="form-group">
            <label for="LocalEquiv">{{ 'ADMIN_USER.SmallUnits.FINALFEES_LOCALEQUIV' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="LocalEquiv" id="LocalEquiv" name="LocalEquiv" (change)="localEquivChanged($event)" class="form-control" />
            <div *ngIf="submitted || (f.LocalEquiv?.dirty &&f.LocalEquiv?.errors)" class="red">
              <div *ngIf="f.LocalEquiv?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.LocalEquiv?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
            </div>
          </div>

          <div class="form-group">
            <label for="InvoiceNo">{{ 'ADMIN_USER.SmallUnits.FINALFEES_INVOICENO' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="InvoiceNo" id="InvoiceNo" name="InvoiceNo"  class="form-control" />
            <div *ngIf="submitted || (f.InvoiceNo?.dirty &&f.InvoiceNo?.errors)" class="red">
              <div *ngIf="f.InvoiceNo?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
            </div>
        </div>

                <!-- Services Section -->
                <div formArrayName="SmallUnitServices" class="form-container">
                  <h4  *ngIf="(formMode!= FormMode.Readonly)||(formMode == FormMode.Readonly && this.finalFeesForm.get('SmallUnitServices').lenght > 0)" class="section-title">{{'ADMIN_USER.SmallUnits.FINALFEES_SERVICES'| translate}}</h4>
                    <div *ngFor="let services of finalFeesForm.get('SmallUnitServices')['controls']; let i=index; let last = last" [formGroupName]="i" class="read-only-content">
                        <div class="form-container">
                            <div class="form-section">

                            <div class="form-group">
                                <label for="ServiceName">{{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_NAME' | translate}}</label>
                                <span class="red">*</span>
                                <select formControlName="ServiceName" class="form-control" id="ServiceName" name="ServiceName">
                                      <option value="" selected>{{ 'FRONT_USER.small_units.CHOOSE' | translate }}</option>

                                      <option value='Entry'>
                                          {{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICENAME_ENTRY' | translate }}
                                      </option>
                                      <option value='Shift'>
                                          {{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICENAME_SHIFT' | translate }}
                                      </option>
                                      <option value='Departure'>
                                        {{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICENAME_DEPARTURE' | translate }}
                                    </option>
                                </select>
                                <div *ngIf=" submitted ||(services.get('ServiceName')?.dirty && services.get('ServiceName')?.errors)"
                                    class="red ">
                                    <div *ngIf="services.get('ServiceName')?.errors?.required">
                                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                              <label for="ServiceDate">{{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_DATE' | translate }}</label>
                              <span class="red">*</span>
                              <div class="split-form-group ">
                                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker [minDate]="null" [maxDate]='todayDate' formControlName="ServiceDate">
                                <timepicker id="ServiceTime" formControlName="ServiceTime" [hourStep]="1" [minuteStep]="1"></timepicker>
                              </div>

                              <div *ngIf="submitted ||(services.get('ServiceDate')?.dirty && services.get('ServiceDate')?.errors)" class="red ">
                                <div *ngIf="services.get('ServiceDate')?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                                <div *ngIf="services.get('ServiceDate')?.errors?.inValidDateError">
                                  {{'FRONT_USER.DATE_ERROR' | translate}}
                                </div>
                              </div>
                              <div *ngIf="submitted ||(services.get('ServiceTime')?.dirty && services.get('ServiceTime')?.errors)" class="red ">
                                <div *ngIf="services.get('ServiceTime')?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                              </div>
                              <!-- <div *ngIf="error.isError" class="red">
                                {{ error.errorMessage }}
                              </div> -->
                            </div>

                            <div class="form-group">
                                <label for="ServiceDayNight">{{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_DAYNIGHT' | translate}}</label>
                                <select formControlName="ServiceDayNight" class="form-control" id="ServiceDayNight" name="ServiceDayNight">
                                      <option value='' selected>{{ 'FRONT_USER.small_units.CHOOSE' | translate }}</option>

                                      <option value='Day'>
                                          {{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_DAYNIGHT_DAY' | translate }}
                                      </option>
                                      <option value='Night'>
                                          {{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_DAYNIGHT_NIGHT' | translate }}
                                      </option>
                                </select>
                                <div *ngIf=" submitted ||(services.get('ServiceDayNight')?.dirty && services.get('ServiceDayNight')?.errors)"
                                    class="red ">
                                    <div *ngIf="services.get('ServiceDayNight')?.errors?.required">
                                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="ServiceValue">{{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_VALUE' | translate}}</label>
                                <span class="red">*</span>
                                <input type="text" formControlName="ServiceValue" class="form-control" (change)="serviceValueChanged()"
                                    [ngClass]="{ 'is-invalid':submitted ||( services.get('ServiceValue')?.dirty && services.get('ServiceValue')?.errors) }" />
                                <div *ngIf=" submitted ||(services.get('ServiceValue')?.dirty && services.get('ServiceValue')?.errors)"
                                    class="red ">
                                    <div *ngIf="services.get('ServiceValue')?.errors?.required">
                                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                    </div>
                                    <div *ngIf="services.get('ServiceValue')?.errors?.pattern">
                                        {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                      </div>
                                </div>
                            </div>

                            <div class="form-group">
                              <label for="ServiceDesc">{{ 'ADMIN_USER.SmallUnits.FINALFEES_SERVICE_DESC' | translate}}</label>
                              <textarea formControlName="ServiceDesc" id="ServiceDesc" name="ServiceDesc"  class="form-control"
                                       [ngClass]="{ 'is-invalid': submitted ||(f.ServiceDesc?.dirty && f.ServiceDesc?.errors) }"></textarea>
                              <div *ngIf=" submitted ||(services.get('ServiceDesc')?.dirty && services.get('ServiceDesc')?.errors)"
                                  class="red ">
                                    <div *ngIf="services.get('ServiceDayNight')?.errors?.maxlength">
                                      {{'FRONT_USER.TEXT_MAX_LENGTH_200_ERROR' | translate}}
                                  </div>
                              </div>
                          </div>
                            <div *ngIf="formMode != FormMode.Readonly && this.SUServices.length > 1" class="btns-holder">
                                <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="DeleteSUservice(i)">
                                    {{'FRONT_USER.DELETE' | translate }}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
        </div>
        <div class="form-container">
            <!-- <h4 *ngIf ='formMode!= FormMode.Readonly && this.SUServices.length < 1' class="section-title">{{'ADMIN_USER.SmallUnits.FINALFEES_SERVICES'| translate}}</h4> -->
            <div *ngIf="formMode!= FormMode.Readonly" class="btns-holder">
                <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="AddSUservice()">
                {{'ADMIN_USER.SmallUnits.FINALFEES_ADD_SERVICE' | translate}}
                </button>
            </div>

        </div>

        <div class="form-container">
            <div class="form-section">
                <!-- Final Fees Section -->
                <h4 class="section-title">{{'ADMIN_USER.SmallUnits.FINALFEES_TOTAL_FEES'| translate}}</h4>
                <div class="form-group">
                    <label for="FinalTotalFees">{{ 'ADMIN_USER.SmallUnits.FINALFEES_TOTAL_FEES' | translate}}</label>
                    <span class="red">*</span>
                    <input type="text" formControlName="FinalTotalFees" id="FinalTotalFees" name="FinalTotalFees"
                    class="form-control" (ngModelChange)="finalfeesChanged()" />
                    <div *ngIf="submitted || (f.FinalTotalFees?.dirty &&f.FinalTotalFees?.errors)" class="red">
                        <div *ngIf="f.FinalTotalFees?.errors?.required">
                            {{'FRONT_USER.This_Field_Is_Required' | translate}}
                        </div>
                        <div *ngIf="f.FinalTotalFees?.errors?.pattern">
                            {{'FRONT_USER.NUMBER_ERROR' | translate}}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                  <label for="FinalTotalFeesLE">{{ 'ADMIN_USER.SmallUnits.FINALFEES_TRANSIT_FEES_LE' | translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="FinalTotalFeesLE" id="FinalTotalFeesLE" name="FinalTotalFeesLE"
                  class="form-control" />
                  <div *ngIf="submitted || (f.FinalTotalFeesLE?.dirty &&f.FinalTotalFeesLE?.errors)" class="red">
                      <div *ngIf="f.FinalTotalFeesLE?.errors?.required">
                          {{'FRONT_USER.This_Field_Is_Required' | translate}}
                      </div>
                      <div *ngIf="f.FinalTotalFeesLE?.errors?.pattern">
                          {{'FRONT_USER.NUMBER_ERROR' | translate}}
                      </div>
                  </div>
              </div>
            </div>
        </div>
      </fieldset>

        <div *ngIf="formMode == FormMode.Add" class="form-group">
          <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
            'FRONT_USER.SUBMIT' | translate}}</button>
        </div>
    </form>

    <br>

    <!-- </div> -->
  </div>
  <!-- Confirmation -->
  <div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
    <div class="alignC">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
          <g>
            <path
              d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
            </path>
          </g>
        </g>
      </svg>
      <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>

    </div>
  </div>

  <!-- error message -->
  <div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
      <i class="icon-error"></i>

      <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
  </div>

  <div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
    <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
  </div>
